import { render } from "./index.vue?vue&type=template&id=52e6db88"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=52e6db88&lang=scss"

import exportComponent from "D:\\react js\\VET_VUE\\VET-mini-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__